// The global bar (brief §4.1): live indicator with last-updated time, search by ENQ / MD /
// shipment id, and the City / Type / EC / Carrier filters (Carrier hidden on the POs tab).
// EC = the order's Experience Centre (its estimate's branch); a PO or shipment follows its order.
import { ReloadOutlined } from "@ant-design/icons";
import { Button, Input, Select, Tooltip } from "antd";
import dayjs from "dayjs";
import React, { useState } from "react";
import { CARRIER_LABEL, DELIVERY_TYPE_LABEL } from "../config/stages";
import { OcCarrier, OcDeliveryType, OcTab } from "../types";
import { OcBranchOption } from "../types/orders";
import styles from "../index.module.scss";

// Origin hub cities (the OMS hubs are in Bengaluru and Hyderabad).
const CITY_OPTIONS = ["Bengaluru", "Hyderabad"].map((c) => ({ label: c, value: c }));
const TYPE_OPTIONS = (Object.keys(DELIVERY_TYPE_LABEL) as OcDeliveryType[]).map((k) => ({ label: DELIVERY_TYPE_LABEL[k], value: k }));
const CARRIER_OPTIONS = (Object.keys(CARRIER_LABEL) as OcCarrier[]).map((k) => ({ label: CARRIER_LABEL[k], value: k }));

interface Props {
  tab: OcTab;
  cities: string[];
  types: OcDeliveryType[];
  carriers: OcCarrier[];
  branches: string[];
  branchOptions: OcBranchOption[];
  onCities: (v: string[]) => void;
  onTypes: (v: OcDeliveryType[]) => void;
  onCarriers: (v: OcCarrier[]) => void;
  onBranches: (v: string[]) => void;
  onSearch: (q: string) => void;
  searching: boolean;
  updatedAt: Date | null;
  loading: boolean;
  onRefresh: () => void;
  isMock: boolean;
}

const GlobalBar: React.FC<Props> = (p) => {
  const [q, setQ] = useState("");
  return (
    <div className={styles.globalBar}>
      <Input.Search
        className={styles.search}
        placeholder="Search ENQ or MD"
        allowClear
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onSearch={(v) => v.trim() && p.onSearch(v.trim())}
        loading={p.searching}
      />
      <Select
        mode="multiple"
        allowClear
        placeholder="City"
        className={styles.filter}
        options={CITY_OPTIONS}
        value={p.cities}
        onChange={p.onCities}
        maxTagCount="responsive"
      />
      <Select
        mode="multiple"
        allowClear
        placeholder="Delivery type"
        className={styles.filter}
        options={TYPE_OPTIONS}
        value={p.types}
        onChange={p.onTypes}
        maxTagCount="responsive"
      />
      <Select
        mode="multiple"
        allowClear
        showSearch
        optionFilterProp="label"
        placeholder="EC"
        className={styles.filter}
        options={p.branchOptions}
        value={p.branches}
        onChange={p.onBranches}
        maxTagCount="responsive"
      />
      {p.tab !== "pos" ? (
        <Select
          mode="multiple"
          allowClear
          placeholder="Carrier"
          className={styles.filter}
          options={CARRIER_OPTIONS}
          value={p.carriers}
          onChange={p.onCarriers}
          maxTagCount="responsive"
        />
      ) : null}
      <div className={styles.live}>
        <span className={p.loading ? styles.liveDotBusy : styles.liveDot} />
        <span>{p.isMock ? "Mock data" : "Live"}</span>
        <span className={styles.muted}>· updated {p.updatedAt ? dayjs(p.updatedAt).format("HH:mm:ss") : "—"}</span>
        <Tooltip title="Refresh now">
          <Button size="small" type="text" icon={<ReloadOutlined spin={p.loading} />} onClick={p.onRefresh} />
        </Tooltip>
      </div>
    </div>
  );
};

export default GlobalBar;
